module.exports = __webpack_public_path__ + "static/tai-logo-1af9b9646ebc4416dcad399be3180739.svg";